import PropTypes from "prop-types";
import content from "app-content";
import CurrentPricePrefix from "../CurrentPricePrefix";

const CurrentPriceExtendedPrefix = ({
  hasMultiplePricesInStock,
  variantId,
  priceInfo
}) => {
  const prefix = CurrentPricePrefix({ hasMultiplePricesInStock, variantId });
  if (prefix !== null) {
    return prefix;
  }

  if (priceInfo.isDiscounted) {
    return <span>{content.now_pricing_label}</span>;
  }

  return null;
};

CurrentPriceExtendedPrefix.propTypes = {
  hasMultiplePricesInStock: PropTypes.bool.isRequired,
  variantId: PropTypes.number,
  priceInfo: PropTypes.shape({
    isDiscounted: PropTypes.bool
  }).isRequired
};

export default CurrentPriceExtendedPrefix;
